import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IFleetState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const fleetModule: Module<IFleetState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default fleetModule
